import React from 'react';
import ConfiguratorOption from '../ConfiguratorOption';
import KeinMontage from '../../images/7/reactcode/KeinMontage';
import MitMontage from '../../images/7/reactcode/MitMontage';


interface ProductAssemblyProps {
  selected: string;
  onSelect: (product: string) => void;
}

const ProductAssembly: React.FC<ProductAssemblyProps> = ({ selected, onSelect }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 gap-x-2 gap-y-2 w-full">
      <ConfiguratorOption
        label="Ja, ich möchte einen Montageservice"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/assembly1.svg`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/assembly1.svg`}
        onClick={() => onSelect("Ja, ich möchte einen Montageservice")}
        isSelected={selected === "Ja, ich möchte einen Montageservice"}
        SVGComponent={MitMontage}
      />
      <ConfiguratorOption
        label="Nein, ich möchte selbst montieren."
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/assembly2.svg`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/assembly2.svg`}
        onClick={() => onSelect('Nein, ich möchte selbst montieren.')}
        isSelected={selected === "Nein, ich möchte selbst montieren."}
        SVGComponent={KeinMontage}


      />
    </div>
  );
};

export default ProductAssembly;
